module.exports = __webpack_public_path__ + "src/img/reset-green.cab40046.svg";